export default __webpack_public_path__ + "static/media/gama.75235334.svg";